import { ArrowRightIcon } from "@heroicons/react/solid";
import React from "react";

export default function Navbar() {
    return (
        <header className="bg-white md:sticky top-0 z-10">                
          <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
            <a href="#about" className="mb-4 md:mb-0">
              <img src="/podconn_logo_nav.png" alt="Podconn logo" />
            </a>    
            <nav className="text-gray-900 md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l md:border-gray-700	flex flex-wrap items-center text-lg justify-center">
              <a href="#skills" className="mr-5 font-medium hover:text-gray-700">
                Technologies
              </a>
              <a href="#projects" className="mr-5 font-medium hover:text-gray-700">
                Deployments
              </a>
              <a href="#partners" className="mr-5 font-medium hover:text-gray-700">
                Partners
              </a>
            </nav>
            <a
              href="#contact"
              className="inline-flex items-center text-gray-50 bg-gray-800 border-0 py-1 px-3 focus:outline-none hover:bg-gray-700 rounded text-base mt-4 md:mt-0">
              Contact Us
              <ArrowRightIcon className="w-4 h-4 ml-1" />
            </a>
          </div>
        </header>
    );
}


// WEBPACK FOOTER //
// ./src/components/Navbar.js